import React, {useEffect, useState} from 'react'
import {Button, Form, Input, Modal, AutoComplete, InputNumber, Popconfirm} from "antd";
import {getAllSupplier} from "../../../services/serviceSupplier";
import {createPurchase} from "../../../services/servicePurchase";
import {createShippingOrder} from "../../../services/serviceShippingOrder";
import {useParams} from "@reach/router";

const {Option} = AutoComplete

const OfferDetailActions = ({record, offer}) => {

    const {offerId} = useParams()
    const [form] = Form.useForm()
    const [purchase, setPurchase] = useState(false)
    const [shipping, setShipping] = useState(false)
    const [suppliers, setSuppliers] = useState([])
    const [selectedSupplier, setSelectedSupplier] = useState(0)
    const [showPurchaseModal, setShowPurchaseModal] = useState(false)

    useEffect(() => {
        if (record.offerQuantity > record.stockQuantity) {
            setShipping(true)
            let missingValue = record.offerQuantity - record.stockQuantity
            form.setFieldsValue({
                stockValue: record.stockQuantity,
                purchaseStock: missingValue
            })
        } else {
            setPurchase(true)
        }

    }, [])

    const handleSupplierChange = (v, o) => setSelectedSupplier(o.key)

    const handlePurchase = () => {
        getAllSupplier()
            .then(({data}) => {
                let supplierData = data.map(item => {
                    return {
                        text: `${item.name} ${item.description || ''}`,
                        value: item.id
                    }
                })
                setSuppliers(supplierData)
                setShowPurchaseModal(!showPurchaseModal)
            })
    }

    const handlePurchaseSubmit = () => {
        const {
            purchaseStock
        } = form.getFieldsValue()

        const requestObj = {
            quantity: purchaseStock,
            bidId: Number(offerId),
            stockId: record.offerStockId,
            supplierId: Number(selectedSupplier)
        }

        createPurchase(requestObj)
            .then(() => setShowPurchaseModal(!showPurchaseModal))
    }
    const handleShippingSubmit = () => {
        createShippingOrder({
            quantity: record.offerQuantity,
            customer: offer.bid.customer.id,
            stock: record.offerStockId
        })
    }

    return (
        <React.Fragment>
            <Popconfirm title={'Sevk Emri oluşturmak istiyor musunuz ?'} disabled={shipping}
                        onConfirm={handleShippingSubmit}
            >
                <Button
                    type={'primary'}
                    disabled={shipping}
                >
                    Sevk Emri
                </Button>
            </Popconfirm>
            <Button
                hidden
                type={'primary'}
                danger
                disabled={purchase}
                onClick={handlePurchase}
            >
                Satın Alma
            </Button>

            {/*PURCHASE MODAL */}
            <Modal
                open={showPurchaseModal}
                title={`${record.offerStock} Satın Alma`}
                onCancel={() => setShowPurchaseModal(!showPurchaseModal)}
                footer={[
                    <Button key={'SubmitButton'} type={'primary'} onClick={handlePurchaseSubmit}>Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={() => setShowPurchaseModal(!showPurchaseModal)}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    wrapperCol={{span: 16}}
                    labelCol={{span: 8}}
                >
                    <Form.Item
                        name={'stockValue'}
                        label={'Stok Miktarı'}
                    >
                        <Input disabled/>
                    </Form.Item>
                    <Form.Item
                        name={'purchaseStock'}
                        label={'Sipariş Miktarı'}
                    >
                        <InputNumber min={0.1} step={0.1}/>
                    </Form.Item>
                    <Form.Item
                        name={'purchaseSupplier'}
                        label={'Tedarikçi'}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onChange={handleSupplierChange}
                        >
                            {suppliers.map(({value, text}) => {
                                return <Option key={value} value={text}>{text}</Option>
                            })}
                        </AutoComplete>
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default OfferDetailActions